module.exports = require("remark-slug");


//////////////////
// WEBPACK FOOTER
// external "remark-slug"
// module id = 59
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13